"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// Idp components.
var Modal_1 = require("../../atoms/Modal");
// Utilities.
var ModalStyle = require("./LegalDisclaimerPopup.css");
var LegalDisclaimerPopup = /** @class */ (function (_super) {
    __extends(LegalDisclaimerPopup, _super);
    function LegalDisclaimerPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.ModalContent = function (props) {
            var content = props.data.content;
            return typeof content === "string" ?
                React.createElement("div", { className: _this.style.content, dangerouslySetInnerHTML: { __html: content } })
                : React.createElement("div", { className: _this.style.content }, content);
        };
        var options = props.options || {};
        var data = props.data || {};
        _this.style = data.style || ModalStyle;
        return _this;
    }
    LegalDisclaimerPopup.prototype.render = function () {
        var data = this.props.data || {};
        var state = this.state;
        return (React.createElement(Modal_1.default, { events: {
                onClose: function () {
                    if (data.close) {
                        data.close();
                    }
                },
            }, options: {
                center: true,
                className: {
                    modalContentClass: this.style.modalContent,
                    modalMaskClass: 'modal-mask',
                    modalParentClass: this.style.parent,
                },
                show: !!data.content,
                showClose: data.showClose !== false ? true : false,
                size: data.size,
            } },
            this.props.data &&
                React.createElement("h2", { className: "font-medium type-lg color-ui-black" }, this.props.data.modalTitle),
            React.createElement("div", { className: this.style.divider }),
            React.createElement(this.ModalContent, { data: data })));
    };
    return LegalDisclaimerPopup;
}(React.PureComponent));
exports.default = LegalDisclaimerPopup;
//# sourceMappingURL=LegalDisclaimerPopup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/LegalDisclaimerPopup/LegalDisclaimerPopup.js
// module id = 1200
// module chunks = 8